import React, { useEffect, useState } from 'react'
import { cn } from 'ethcss'
import translate from '../../core/translate'
import Icon from '../../blocks.simple/icon/icon'
import { colors } from '../../theme'
import styles from './styles.jcss'

export const SidebarMultiselectMenu = ({ children }: any) => {
    const [menuOpened, setMenuOpened] = useState<boolean>(false)

    const hideMenu = () => {
        if (!menuOpened) return

        setTimeout(() => {
            setMenuOpened(false)
        }, 30)
    }

    useEffect(() => {
        const clickOutside = document.querySelector('.click-outside')
        const targetElement = clickOutside || window

        targetElement.addEventListener('click', hideMenu)

        return () => targetElement.removeEventListener('click', hideMenu)
    }, [menuOpened])

    return (
        <div
            className={styles.wrapper}
            onClick={(e) => {
                if ((e.target as HTMLElement).tagName !== 'A') {
                    e.preventDefault()
                }

                e.nativeEvent.stopImmediatePropagation()
            }}
        >
            <div
                className={cn(styles.selectActionBtn, menuOpened ? styles.active : '')}
                onClick={(e) => {
                    if ((e.target as HTMLElement).tagName !== 'A') {
                        e.preventDefault()
                    }

                    e.nativeEvent.stopImmediatePropagation()

                    setMenuOpened((s) => !s)
                }}
            >
                <div>{translate('actionSelect')}</div>
                <Icon type={'tile'} size={16} color={menuOpened ? colors.blueAccent : ''} />
            </div>
            {menuOpened && <div className={styles.menu}>{children}</div>}
        </div>
    )
}
